import React from 'react';
import iconify from '../iconify';

const PencilStrokedIcon = ({customColor, ...props}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25.58 25.57"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="-905.87"
        y1="564.82"
        x2="-904.87"
        y2="564.82"
        gradientTransform="matrix(18.08, 18.08, 18.08, -18.08, 6170.7, 26596.94)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" />
        <stop offset="1" />
      </linearGradient>
    </defs>
    <g id="Group_297" data-name="Group 297">
      <g id="Group_53" data-name="Group 53">
        <path
          id="Path_44"
          data-name="Path 44"
          d="M20.85,4.72a11.4,11.4,0,1,1-16.12,0h0a11.4,11.4,0,0,1,16.11,0h0m1-1a12.79,12.79,0,1,0,0,18.09,12.8,12.8,0,0,0,0-18.09Z"
          fill="url(#linear-gradient)"
        />
      </g>
    </g>
    <g id="noun_1384723_cc" data-name="noun 1384723 cc">
      <path
        id="Path_131"
        data-name="Path 131"
        d="M7.4,14.72l-1.33,4,4-1.34,9.32-9.32a1,1,0,0,0,0-1.34L18.06,5.39a.94.94,0,0,0-1.33,0Z"
        fill="none"
        stroke="#ea4154"
        stroke-width="1"
      />
      <line
        id="Line_32"
        data-name="Line 32"
        x1="18.06"
        y1="9.39"
        x2="15.4"
        y2="6.72"
        fill="none"
        stroke="#ea4154"
        stroke-width="1"
      />
      <line
        id="Line_33"
        data-name="Line 33"
        x1="10.07"
        y1="17.38"
        x2="7.4"
        y2="14.72"
        fill="none"
        stroke="#ea4154"
        stroke-width="1"
      />
    </g>
  </svg>
);

export default iconify(PencilStrokedIcon);
